import { WORKSHEET_ID, worksheetActionTypes } from '../data/constants';

const initialItem = {
  interactionsLocked: false,
  displayFeedback: false,
  visible: true,
  isAvailable: true,
};

const initialState = [];

/**
 * worksheetChoicesReducer contains an array of js objects which dictate the props for a
 * collection of worksheetChoiceContainers. Listens for a few actions that can set individual values
 * for a specific item in the array.
 */
const choicesReducer = (state = initialState, action) => {
  if (action.gameId !== WORKSHEET_ID) {
    return state;
  }

  switch (action.type) {
    case worksheetActionTypes.INIT_WORKSHEET: {
      const newState = [];
      for (let i = 0; i < action.payload.count; i++) {
        newState.push({ ...initialItem });
      }
      return newState;
    }
    case worksheetActionTypes.SET_DISPLAYING_FEEDBACK: {
      const { index, value } = action.payload;
      const newState = [...state];
      const newItem = { ...state[index] };
      newItem.displayFeedback = value;
      newState[index] = newItem;
      return newState;
    }
    case worksheetActionTypes.SET_VISIBLE: {
      const { index, value } = action.payload;
      const newState = [...state];
      const newItem = { ...state[index] };
      newItem.visible = value;
      newState[index] = newItem;
      return newState;
    }
    case worksheetActionTypes.SET_IS_AVAILABLE: {
      const newState = [...state];
      const newItem = { ...state[action.payload.index] };
      newItem.isAvailable = action.payload.value;
      newState[action.payload.index] = newItem;
      return newState;
    }
    default:
      return state;
  }
};

export default choicesReducer;
